<app-users-reports-table [users]="users$ | async">
</app-users-reports-table>